import { graphql } from 'gatsby';
import useLinkProps from '@/components/Link/hooks/useLinkProps';
import {
  StyledLinkText,
  StyledShortDescription,
  StyledTag,
  StyledTitle,
  StyledCard,
  StyledContainer,
  StyledImage,
} from './Card.styles';
import { breakpoints } from '@/constants/breakpoints';

const IMAGE_WIDTH = 325;
const IMAGE_HEIGHT = 200;

interface CardProps extends Queries.CARDFragment {
  className?: string;
}

const Card = ({ elements, system, className }: CardProps) => {
  const {
    headline,
    image,
    link: {
      value: { linkElements },
    },
    body,
    eyebrow,
  } = elements;
  const { linkChildren, linkProps: cardLinkProps } = useLinkProps({
    action: linkElements.action.value,
    target: linkElements.target?.value,
  });
  const imageCard = image?.value && {
    ...image.value,
    description: image.value.description || `Image for ${headline.value}`,
    width: IMAGE_WIDTH,
    height: IMAGE_HEIGHT,
  };
  const linkText = `${linkElements.text.value} >`;
  const hasEyebrow = !!eyebrow?.value;

  return (
    <StyledCard data-codename={system.codename} {...cardLinkProps} className={className}>
      {linkChildren}
      {imageCard && (
        <StyledImage
          src={imageCard.url}
          alt={imageCard.description}
          sizes={[
            {
              width: 500,
              height: 307.69,
            },
            {
              breakpoint: breakpoints.TABLET,
              width: 720,
              height: 443,
            },
            {
              breakpoint: breakpoints.DESKTOP,
              width: 352,
              height: 217,
            },
          ]}
        />
      )}

      <StyledContainer>
        {hasEyebrow && <StyledTag>{eyebrow.value}</StyledTag>}
        <StyledTitle>{headline.value}</StyledTitle>
        <StyledShortDescription>{body.value}</StyledShortDescription>
        <StyledLinkText>{linkText}</StyledLinkText>
      </StyledContainer>
    </StyledCard>
  );
};

export default Card;

export const fragment = graphql`
  fragment CARD on kontent_item_card {
    __typename
    elements {
      headline {
        value
      }
      image {
        value {
          url
          description
        }
      }

      link {
        value {
          ...LINK
        }
      }
      body {
        value
      }
      eyebrow {
        value
      }
    }
    system {
      codename
      id
    }
  }
`;
